import React, { forwardRef } from 'react';
import {
  DataTable as PrimeDataTable,
  DataTableProps,
  DataTableValueArray,
} from 'primereact/datatable';
import useIsMobile from '../../../hooks/global/UseIsMobile';

/**
 * `DataTable` PrimeReacta, w którym `responsiveLayout="stack"` znaczy „karty tylko na telefonie”.
 * W trybie `stack` PrimeReact wstawia nagłówek kolumny do KAŻDEJ komórki (etykieta w karcie) — na
 * desktopie mnożyło to komponenty (np. tooltip z nagłówka w każdym wierszu, z tym samym `id`), więc
 * poza telefonem idzie domyślny `scroll`. Tryb śledzi próg na żywo (`useIsMobile`): po obrocie telefonu
 * tabela przełącza się sama, bez czekania, aż strona się przerenderuje.
 * Inne wartości `responsiveLayout` przechodzą bez zmian.
 */
const DataTableInner = <TValue extends DataTableValueArray>(
  props: DataTableProps<TValue>,
  ref: React.ForwardedRef<PrimeDataTable<TValue>>
) => {
  const isMobile = useIsMobile();
  const responsiveLayout =
    props.responsiveLayout === 'stack' ? (isMobile ? 'stack' : 'scroll') : props.responsiveLayout;
  return <PrimeDataTable ref={ref} {...props} responsiveLayout={responsiveLayout} />;
};

export const DataTable = forwardRef(DataTableInner) as <TValue extends DataTableValueArray>(
  props: DataTableProps<TValue> & { ref?: React.Ref<PrimeDataTable<TValue>> }
) => React.ReactElement;
